// src/domains/user/userProfile.store.ts

import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { IUserProfile } from './user.types';
import { customStorage } from '@/shared/lib/storage';
import { registerClear } from '@/shared/lib/storesRegistry';

interface IUserProfileStore {
  user: IUserProfile | null;
  setUser: (user: IUserProfile) => void;
  clearUser: () => void;
}

export const useUserProfileStore = create<IUserProfileStore>()(
  devtools(
    persist(
      (set) => ({
        user: null,
        setUser: (user) => set({ user: user }),
        clearUser: () => set({ user: null }),
      }),
      { name: 'user-profile-storage', storage: customStorage }, // localstorage
    ),
    { name: 'UserProfileStore' },
  ),
);

registerClear(useUserProfileStore.getState().clearUser);
